import React from 'react';
import { func,number,array } from 'prop-types';
import RadioButton from '../../atoms/RadioButton/index';

export const CustomizableRadioButtonGroup = Component => {
	function RadioButtonGroup({selectedIndex,options,onSelect,onChange,...props}) {
		return options.map((option,idx)=>{
			return (
				<Component 
					{...props}
					key={option+idx}
					onClick={(e)=>{
						onSelect && onSelect(option,idx,e);
					}}
					onChange={(e)=>{
						onChange && onChange(option, idx, e);
					}}
					checked={idx===selectedIndex}
					value={option}
					name={option}
				/>);
		});
	}
	RadioButtonGroup.propTypes = {
		selectedIndex : number.isRequired,
		onSelect : func,
		onChange : func,
		options : array
	};
	return RadioButtonGroup;
};
export const RadioButtonGroup = CustomizableRadioButtonGroup(RadioButton);
